/** How long a newly shipped map is tagged NEW in the map pickers. */
export const NEW_MAP_DAYS = 30

/** Whether a map shipped (MapDef.addedOn, YYYY-MM-DD) within the last NEW_MAP_DAYS. */
export function isNewMap(addedOn: string | undefined, now: number = Date.now()): boolean {
  if (!addedOn) return false
  const added = Date.parse(`${addedOn}T00:00:00Z`)
  if (!Number.isFinite(added)) return false
  const ageDays = (now - added) / 86_400_000
  return ageDays >= 0 && ageDays < NEW_MAP_DAYS
}
